import { useState, useEffect, useCallback } from "react";
import { MOBILE_MAX_WIDTH } from "@/lib/utils/responsive";

/**
 * Hook that returns true when viewport is ≤768px (mobile/tablet).
 * Updates on window resize. Matches Angular isMobileBrowser behavior.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth <= MOBILE_MAX_WIDTH;
  });

  const check = useCallback(() => {
    setIsMobile(window.innerWidth <= MOBILE_MAX_WIDTH);
  }, []);

  useEffect(() => {
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, [check]);

  return isMobile;
}
